import Search from './search'
import Lightbox from './lightbox'
import documentReady from './documentReady'

import Handorgel from './../libraries/handorgel/js/index'
import scrollTop from 'scrolltop'

import SmoothScroll from 'smoothscroll-polyfill'

const globalSettings =
  require('./../globalsettings/globalsettings.json').globals

function positionInDocument(el) {
  const rect = el.getBoundingClientRect()
  const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop

  return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}

class ASVZ {
  /**
   *
   * @param hostName
   */
  constructor() {
    documentReady(() => {
      this.initialize()
    })
  }

  initialize() {
    this.hostName =
      document.location.hostname == 'localhost' ? 'https://asvz.next' : ''
    // objectFitImages();
    this.initToggler()
    this.initSearch()
    this.initLightbox()
    this.initSmoothScroll()

    this.homeFooter = document.getElementById('home-footer')
    this.sponsorSection = document.getElementById('sponsors-section')

    this.initScrollWatcher(this.homeFooter)

    this.sponsorSectionPosition = 0
    this.scrollPosition = 0

    if (this.homeFooter && this.sponsorSection) {
      this.sponsorSectionPosition = positionInDocument(this.sponsorSection)
    }
  }

  initSmoothScroll() {
    SmoothScroll.polyfill()
    const anchors = document.querySelectorAll('.anchor a')
    for (let i = 0; i < anchors.length; i++) {
      const anchor = anchors[i]
      anchor.addEventListener('click', (event) => {
        event.preventDefault()
        const href = anchor.getAttribute('href').replace('#', '')
        const element = document.getElementById(href)
        window.scroll(this.getScrollOptions(element))
      })
    }
  }

  getScrollOptions(element) {
    const scrollY = scrollTop()
    let top = scrollY + element.getBoundingClientRect().top

    let headerSize = document.getElementById('header-main').offsetHeight
    let anchors = document.getElementsByClassName('anchor')

    for (let index = 0; index < anchors.length; index++) {
      headerSize += anchors[index].offsetHeight
    }
    top = top - headerSize

    return {
      top: top,
      left: 0,
      behavior: 'smooth'
    }
  }

  initScrollWatcher() {
    this.scrollPosition = -1

    if (this.homeFooter) {
      this.requestAnimationFrame()
    }
  }

  watchScroll() {
    const scrollY = scrollTop()
    if (scrollY != this.scrollPosition) {
      this.scrollPosition = scrollY
      this.checkHeaderPosition()

      if (
        this.homeFooter &&
        window.innerWidth > globalSettings.breakpoints.md.min
      ) {
        const diff =
          this.sponsorSectionPosition.top - window.innerHeight - scrollY + 128

        if (diff < 0) {
          this.homeFooter.classList.add('is-active')
        } else {
          this.homeFooter.classList.remove('is-active')
        }
      }
    }

    this.requestAnimationFrame()
  }

  checkHeaderPosition() {
    if (this.scrollPosition > window.innerHeight - 180) {
      document.body.classList.add('header-transitioned')
    } else {
      document.body.classList.remove('header-transitioned')
    }
  }

  requestAnimationFrame() {
    this.animationRequestId = window.requestAnimationFrame(
      this.watchScroll.bind(this)
    )
  }

  initLightbox() {
    const galleries = document.getElementsByClassName('lightbox-gallery')
    for (let i = 0; i < galleries.length; i++) {
      new Lightbox(galleries[i])
    }
  }

  /**
   *
   */
  initSearch() {
    const searchElements = document.getElementsByClassName(
      'header-search__form'
    )
    for (let i = 0; i < searchElements.length; i++) {
      new Search(searchElements[i], this.hostName)
    }
  }

  initToggler() {
    const accordionsEl = document.getElementsByClassName('handorgel')

    for (let i = 0; i < accordionsEl.length; i++) {
      const el = accordionsEl[i]
      let accordion = new Handorgel(el, {
        // whether the folds are collapsible
        collapsible: true,
        // whether ARIA attributes are enabled
        ariaEnabled: true,
        // whether W3C keyboard shortcuts are enabled
        keyboardInteraction: true,
        // whether to loop header focus (sets focus back to first/last header
        // when end/start reached)
        carouselFocus: true,
        // attribute for the header or content to open folds at initialization
        initialOpenAttribute: 'data-open',
        // whether to use transition at initial open
        initialOpenTransition: true,
        // delay used to show initial transition
        initialOpenTransitionDelay: 200,
        // header/content class if fold is open
        headerOpenClass: 'handorgel__header--open',
        contentOpenClass: 'handorgel__content--open',
        // header/content class if fold has been opened (transition finished)
        headerOpenedClass: 'handorgel__header--opened',
        contentOpenedClass: 'handorgel__content--opened',
        // header/content class if fold has been focused
        headerFocusClass: 'handorgel__header--focus',
        contentFocusClass: 'handorgel__content--focus',
        // header/content class if fold is disabled
        headerDisabledClass: 'handorgel__header--disabled',
        contentDisabledClass: 'handorgel__content--disabled',
        // header/content class if no transition should be active (applied on
        // resize)
        headerNoTransitionClass: 'handorgel__header--notransition',
        contentNoTransitionClass: 'handorgel__content--notransition'
      })

      const openItem = () => {
        if (
          document.location.hash &&
          document.location.hash.indexOf('#details') === 0
        ) {
          const itemID = document.location.hash.replace('#details', 'handorgel')
          let fold = accordion.folds.find((v) => v.id === itemID && !v.expanded)

          if (!fold) {
            const matches = /fold(\d{1,2})/.exec(itemID)
            if (matches) {
              const index = parseInt(matches[1]) - 1
              fold = accordion.folds[index]
            }
          }

          if (fold) {
            fold.open()
            setTimeout(() => {
              window.scroll(this.getScrollOptions(fold.button))
            }, 30)
          }
        }
      }

      if (accordion) {
        accordion.on('fold:opened', (fold) => {
          const id = fold.id
          document.location.hash = id.replace('handorgel', 'details')
        })

        window.addEventListener('hashchange', () => {
          openItem()
        })

        openItem()
      }
    }
  }

  toggle(event) {
    let originalTarget,
      target = event.target
    let className = 'toggled'

    if (!target.hasAttribute('data-toggle')) {
      for (let parentElement of event.path) {
        if (parentElement.hasAttribute('data-toggle')) {
          target = originalTarget = parentElement
          break
        }
      }
    }

    if (target.hasAttribute('data-class')) {
      className = target.getAttribute('data-class')
    }

    if (target.hasAttribute('data-parent')) {
      if (target.getAttribute('data-parent') === '') {
        target = target.parentNode
      } else if (target.getAttribute('data-parent') === 'body') {
        target = document.body
      } else {
        for (let parentElement of event.path) {
          if (
            this.hasClass(parentElement, target.getAttribute('data-parent'))
          ) {
            target = parentElement
            break
          }
        }
      }
    }

    this.toggleClass(originalTarget, 'toggled')
    this.toggleClass(target, className)
  }

  toggleClass(el, className) {
    if (this.hasClass(el, className)) {
      this.removeClass(el, className)
    } else {
      this.addClass(el, className)
    }
  }

  removeClass(el, className) {
    el.setAttribute(
      'class',
      el.getAttribute('class').replace(className, '').trim()
    )
  }

  addClass(el, className) {
    el.setAttribute('class', el.getAttribute('class') + ' ' + className)
  }

  hasClass(el, className) {
    if (el.classList) {
      return el.classList.contains(className)
    } else {
      return new RegExp('(^| )' + className + '( |$)', 'gi').test(el.className)
    }
  }
}

export default ASVZ
